import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  lyrics: {
    id: 't.lyrics',
    defaultMessage: 'Lyrics',
  },
  seeAllLyrics: {
    id: 't.seeAllLyrics',
    defaultMessage: 'See All Lyrics',
  },
  fullLyrics: {
    id: 't.fullLyrics',
    defaultMessage: 'Full Lyrics',
  },
  hideFullLyrics: {
    id: 't.hideFullLyrics',
    defaultMessage: 'Hide Full Lyrics',
  },
  released: {
    id: 't.released',
    defaultMessage: 'Released',
  },
  writtenBy: {
    id: 't.writtenBy',
    defaultMessage: 'Written By',
  },
  producedBy: {
    id: 't.producedBy',
    defaultMessage: 'Produced By',
  },
  performedBy: {
    id: 't.performedBy',
    defaultMessage: 'Performed By',
  },
  lyricsLicensed: {
    id: 't.lyricsLicensed',
    defaultMessage: 'Lyrics Licensed & Provided by LyricFind',
  },
} as const);

export const LyricsStyles = Object.freeze({
  NOW_PLAYING: 'nowPlaying',
  BG: 'bg',
  LIGHT_THEME: 'lightTheme',
} as const);
